import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetGodowns() {

    let data = `
    <ENVELOPE Action="">
        <HEADER>
            <VERSION>1</VERSION>
            <TALLYREQUEST>EXPORT</TALLYREQUEST>
            <TYPE>COLLECTION</TYPE>
            <ID>CUSTOMGODOWNCOL</ID>
        </HEADER>
        <BODY>
            <DESC>
            <STATICVARIABLES>
                    <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
            </STATICVARIABLES>
            <TDL>
                <TDLMESSAGE>
                <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="CUSTOMGODOWNCOL">
                    <TYPE>GODOWN</TYPE>
                    <NATIVEMETHOD>*</NATIVEMETHOD>
                </COLLECTION>
                </TDLMESSAGE>
            </TDL>
            </DESC>
        </BODY>
    </ENVELOPE>
    `

    data = xmlFormatter(data)
    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data
            window.localStorage.setItem(`tally-${TallyConfig.company}-godowns`, JSON.stringify(jsonData))

            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}